import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private clickSubject = new Subject<void>();
  clickTriggered$ = this.clickSubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: object) { }
  public servicesShowingSubRegion = new Subject();

  public showAIExplanationForProductSubject = new Subject<any>();
  public individualProductsPageSubject = new Subject<{type: string ,val?: string}>();
  public editProductIdSubject = new Subject();


  isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  setItem(key: string, value: any) {
    if (!this.isBrowser()) return;
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string) {
    if (!this.isBrowser()) return;
    return localStorage.getItem(key);
  }

  triggerClick() {
    this.clickSubject.next();
  }
  private selectMyTabToggle = new Subject<void>();
  selectMyTab$ = this.selectMyTabToggle.asObservable();

  triggerSelectMyTab(index: any) {
    this.selectMyTabToggle.next(index);
  }

  private nowChattingSubject = new BehaviorSubject<any>(null);
  nowChattingSubject$ = this.nowChattingSubject.asObservable();

  public getNowChatttingValue() {
    return this.nowChattingSubject.value;
  }
  public chatNowSubject = new BehaviorSubject(null);

  triggerChatNow(params: any = {}) {
    if ('chatingNow' in params && 'chatTitle' in params) {
      if (!params['chatTitle']) {
        params['chatTitle'] = 'Unknown';
      }
      if (!params['lastSeenTime']) {
        params['lastSeenTime'] = '...';
      }
    } else {
      console.warn('Some values are missing in chat trigger');
    }

    this.chatNowSubject.next(params);
  }

  private initChatBotSellerSubject = new Subject<void>();
  initSeller$ = this.initChatBotSellerSubject.asObservable();

  triggerInitSeller(params: any = {}) {
    this.initChatBotSellerSubject.next(params);
  }

  // tabs profile ==> marketplace-profile
  private initTabProfileSubject = new Subject<void>();
  initTabProfile$ = this.initTabProfileSubject.asObservable();

  triggerInitTabProfile(arg: any) {
    this.initTabProfileSubject.next(arg);
  }

  // tabs marketplace profile ==> marketplace-profile-character
  private initMarketProfileSubject = new Subject<void>();
  initMarketProfile$ = this.initMarketProfileSubject.asObservable();

  triggerInitMarketProfile(arg: any) {
    this.initMarketProfileSubject.next(arg);
  }
  // tabs profile ==> marketplace-profile-character
  private initProfileSubject = new Subject<void>();
  initProfile$ = this.initProfileSubject.asObservable();

  triggerInitProfile(arg: any) {
    this.initProfileSubject.next(arg);
  }

  private initTopicSubject = new Subject<void>();
  initTopic$ = this.initTopicSubject.asObservable();

  triggerInitTopic(arg: any) {
    this.initTopicSubject.next(arg);
  }

  //member-page ==> community/me
  // private functionCallProduct = new Subject<any>();
  // functionCall$ = this.functionCallProduct.asObservable();

  // callProductFunction(arg: any) {
  //     this.functionCallProduct.next(arg);
  // }

  private initFocusInputChat = new Subject<any>();
  focusInputChat$ = this.initFocusInputChat.asObservable();

  focusInputChat(arg: any) {
    this.initFocusInputChat.next(arg);
  }

  private initShepherd = new Subject<any>();
  shepherd$ = this.initShepherd.asObservable();

  shepherd(arg: any) {
    this.initShepherd.next(arg);
  }

  // tabs members ==> members
  private initMembersSubject = new Subject<void>();
  initMembers$ = this.initMembersSubject.asObservable();

  triggerInitMembers(arg: any) {
    this.initMembersSubject.next(arg);
  }

  private profileServiceSubject = new Subject<any>();
  profileService$ = this.profileServiceSubject.asObservable();

  triggerProfileService(arg: any) {
    this.profileServiceSubject.next(arg);
  }

  private SingleProductServiceSubject = new Subject<any>();
  SingleProductService$ = this.SingleProductServiceSubject.asObservable();

  triggerSingleProductService(arg: any) {
    this.SingleProductServiceSubject.next(arg);
  }
  private openExperienceSubject = new Subject<any>();
  openExperience$ = this.openExperienceSubject.asObservable();

  triggerOpenExperience(arg: any) {
    this.openExperienceSubject.next(arg);
  }

  private openProductDetailSubject = new Subject<any>();
  openProductDetail$ = this.openProductDetailSubject.asObservable();

  triggerOpenProductDetail(arg: any) {
    this.openProductDetailSubject.next(arg);
  }
}
